export const NAME = 'userInfo';

export const USER_ROLE = {
	AGENCY_MANAGER: 'AGENCY_MANAGER',
	CENTRAL: 'CENTRAL',
	DISTRICT_MANAGER: 'DISTRICT_MANAGER',
	GROUP_MANAGER: 'GROUP_MANAGER',
	GUARANTOR: 'GUARANTOR',
	PPZ: 'PPZ',
	REGION_MANAGER: 'REGION_MANAGER',
	SELLER: 'SELLER',
};
